import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "framework";

const keys = addTranslations(RESOURCE_NAME, {
    breadcrumb_frameworks: {
        en: "Frameworks",
        fr: "Référentiels",
    },
    table_section_title: {
        en: "Projects",
        fr: "Projets",
    },
    table_header_name: {
        en: "Project",
        fr: "Projet",
    },
    table_header_status: {
        en: "Status",
        fr: "Statut",
    },
    table_header_last_modified: {
        en: "Last modified at",
        fr: "Dernière mise à jour",
    },
    table_header_progress: {
        en: "Completion",
        fr: "Progression",
    },
    table_header_assignees: {
        en: "Assignees",
        fr: "Assignés",
    },
    empty_state_title: {
        en: "No projects yet. Create a new one to get started.",
        fr: "Aucun projet pour le moment. Créez-en un nouveau pour commencer.",
    },
    about_section_title: {
        en: "About",
        fr: "À propos",
    },
    faq: {
        en: "Frequently asked questions",
        fr: "Questions fréquentes",
    },
    about_demo_link: {
        en: "Watch demo",
        fr: "Regarder la démo",
    },
    about_official_website: {
        en: "Visit website",
        fr: "Visiter le site officiel",
    },
    expertise_guidance: {
        en: "Ditto Guidance",
        fr: "Guidance Ditto",
    },
    expertise_guidance_description: {
        en: "Coming soon!",
        fr: "Bientôt disponible !",
    },
    view_full_guidance: {
        en: "View full guidance",
        fr: "Afficher la guidance complète",
    },
    full_guidance_title: {
        en: "Ditto Guidance",
        fr: "Guidance Ditto",
    },
});
export function useFrameworkTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
